export function ToBankAccountList(_bankAccountList: any) {
  const bankAccountList = [];
  if (_bankAccountList !== null) {
    for (let i = 0; i < _bankAccountList.length; i++) {
      const bankAccountData = {
        id: _bankAccountList[i].id,
        merchantId: _bankAccountList[i].merchantId,
        name: _bankAccountList[i].name,
        bankName: _bankAccountList[i].bankName,
        bankNumber: _bankAccountList[i].bankNumber,
        description: _bankAccountList[i].description,
        bankAccountType: _bankAccountList[i].bankAccountType,
        bankRefTypeId: _bankAccountList[i].bankRefTypeId,
        isCashIn: _bankAccountList[i].isCashIn,
        isCashOut: _bankAccountList[i].isCashOut,
        startAmount: _bankAccountList[i].startAmount,
        haveCheque: _bankAccountList[i].haveCheque,
        bankType: _bankAccountList[i].bankType,
        code: _bankAccountList[i].code,
        urlBankLogo: _bankAccountList[i].urlBankLogo,
        fullName: _bankAccountList[i].fullName,
        status: "null",
      };
      bankAccountList.push(bankAccountData);
    }
  }

  return bankAccountList;
}
